/* src/app/components/control-module/documents/documents.component.css */
/*# sourceMappingURL=documents.component.css.map */
